<style>
  #LayersButton {
    position: absolute;
    top: 0px;
    right: 15px;
    z-index: 51;
    padding: 2px 6px;
    font-size: small;
  }

  #Layers {
    position: absolute;
    top: 0px;
    right: 15px;
    z-index: 50;
    max-height: 99% !important;
    width: 300px;
    overflow-y: auto;
  }

  #Layers .panel {
    border-right: 2px solid #0c9cd8 !important;
    background-color: #dbe2eb;
    border-radius: 0px;
  }

  .vertical-text {
    transform: rotate(90deg);
    transform-origin: left top 0;
  }
</style>
<div>
  <div class="modal-header">
    <h3>Add/Edit {{ meta.verbose_name }} </h3>
    <div class="pull-right" style="margin-top:-10px; cursor: pointer;"
         (click)="history.getHistory(item, meta.type).subscribe()"
         *ngIf="item.globalid !== undefined">
      <div role="button" *ngIf="!history.isVisible">Show History <i class="pull-right fa fa-chevron-right fa-1"
                                                                    style="padding-top: 3px;"></i></div>
      <div role="button" *ngIf="history.isVisible">Hide History <i class="pull-right fa fa-chevron-left fa-1"
                                                                   style="padding-top: 3px;"></i></div>
    </div>
  </div>
  <div class="modal-body" style="padding-right:10px;">
    <div class="row" *ngIf="history.isVisible">
      <div class="col-sm-3 offset-sm-9">
        <div class="row">
          <div class="col-sm-12 pull-right" style="padding-left:0; padding-right: 0; text-align: center;">
            <i role="button"
               (click)="history.index > 0 ? history.index = history.index - 1 : history.index = history.index"
               class="pull-left fa fa-arrow-circle-left fa-2 disabled" style="padding-top:3px;"
               [ngStyle]="history.index === 0 ? {'color':'#AAA', 'cursor':'not-allowed'} : {'cursor':'pointer'}"></i>
            {{ history.data[history.index].from_date | date:'short' }}
            <i role="button"
               (click)="history.index < history.data.length-1 ? history.index = history.index + 1 : history.index = history.index"
               class="pull-right fa fa-arrow-circle-right fa-2"
               style="padding-top: 3px;"
               [ngStyle]="history.index === history.data.length-1 ? {'color':'#AAA', 'cursor':'not-allowed'} : {'cursor':'pointer'}"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngFor="let key of meta.display_fields">
      <!--<input-field meta="meta.fields[key]" item="item" key="{{key}}" dates="dates"></input-field>-->
      <app-dynamic-input [ngClass]="{'col-md-9': history.isVisible, 'col-md-12': !history.isVisible}"
                         [item]="item" [meta]="meta" (metaChange)="resetMeta($event)" [key]="key"></app-dynamic-input>
      <div *ngIf="meta.fields[key].type === 'nested object'">
        <div *ngFor="let key of meta.fields[key].display_fields">
          <div
              [ngClass]="{'has-error': meta.fields[key].children.hasError, 'col-md-2': history.isVisible, 'col-md-3': !history.isVisible}">
            <label class="control-label"
                   [style]="meta.fields[key].children.hasError ? {'padding-top':'30px'} : ''">
              {{ meta.fields[key].label }}
              <span *ngIf="meta.fields[key].required">*</span></label>
          </div>
          <div
              [ngClass]="{'has-error': meta.fields[key].hasError, 'col-md-6': history.isVisible, 'col-md-9': !history.isVisible}"
              [style]="meta.fields[key].hasError ? {'margin-top':'-15px'} : ''">
            <label class="control-label" *ngIf="meta.fields[key].hasError">
              {{ meta.fields[key].errorMessage }}</label>
<!--            <angucomplete-alt *ngIf="key === meta.autocomplete.field"-->
<!--                              id="relatedLookup"-->
<!--                              pause="400"-->
<!--                              placeholder="Search for {{ meta.verbose_name }}"-->
<!--                              selected-object="itemSelected"-->
<!--                              remote-url="{{ meta.autocomplete.url }}"-->
<!--                              remote-url-data-field="results"-->
<!--                              title-field="{{ meta.autocomplete.field }}"-->
<!--                              input-class="form-control"-->
<!--                              initial-value="item"-->
<!--                              override-suggestions="true"-->
<!--                              text-no-results="Not found, press tab to create."></angucomplete-alt>-->
            <input
                *ngIf="(meta.fields[key].type === 'string' || meta.fields[key].type === 'email' ) &&
                        meta.fields[key].choices === undefined"
                type="text"
                class="form-control" [(ngModel)]="item[key]" [required]="meta.fields[key].required"
                placeholder="{{ meta.fields[key].help_text }}"/>

            <input *ngIf="meta.fields[key].type === 'decimal' || meta.fields[key].type === 'float'"
                   type="number" step="0.1"
                   class="form-control"
                   [(ngModel)]="item[key]" string-to-number [required]="meta.fields[key].required"/>

            <input *ngIf="meta.fields[key].type == 'integer'" type="number" step="1"
                   class="form-control"
                   [(ngModel)]="item[key]" [required]="meta.fields[key].required"/>

            <div *ngIf="meta.fields[key].type == 'datetime'" class="row">
              <div class="col-md-4">
                <p class="input-group">
                  <input type="text" class="form-control" uib-datepicker-popup
                         [(ngModel)]="dates[key]" is-open="open[key]"
                         [required]="meta.fields[key].required"/>
                  <span class="input-group-btn">
                            <button type="button" class="btn btn-default" (click)="openCalendar($event, key)">
                                <i class="fa fa-calendar"></i>
                            </button>
                        </span>
                </p>
              </div>
              <div class="col-md-4">
                <div uib-timepicker [(ngModel)]="dates[key]"
                                template-url="custom-timepicker.html"></div>
              </div>
            </div>

            <select
                *ngIf="meta.fields[key].type == 'choice' || (meta.fields[key].type == 'field' && !meta.fields[key].read_only)"
                class="form-control"
                [(ngModel)]="item[key]" [required]="meta.fields[key].required">
              <option *ngFor="let choice of meta.fields[key].choices" [value]="choice.value">
                 {{choice.display_name}}
              </option>
            </select>

            <div style="padding-top:1%;">
              <input *ngIf="meta.fields[key].type == 'boolean'" type="checkbox" [(ngModel)]="item[key]"/>
            </div>
            <!--<select class="form-control" [(ngModel)]="item[key]" [required]="value.required">-->
            <!--<option value="false">No</option>-->
            <!--<option value="true">Yes</option>-->
            <!--</select>-->
          </div>
        </div>

      </div>
      <div class="col-md-3" *ngIf="history.isVisible">
        <!-- <label class="control-label" style="font-weight:normal;" *ngIf="meta.fields[key].type == 'choice'">
             {{ history.data[history.index][key] | display:meta.fields[key].choices }}</label>
         <label class="control-label" style="font-weight:normal;" *ngIf="meta.fields[key].type == 'datetime'">
             {{ history.data[history.index][key] | date:'medium' }}</label>
         <label class="control-label" style="font-weight:normal;" *ngIf="meta.fields[key].type == 'string'">
             {{ history.data[history.index][key] }}</label>
         <label class="control-label" style="font-weight:normal;" *ngIf="meta.fields[key].type == 'boolean'">
             {{ history.data[history.index][key] | display:'boolean' }}</label>-->
        <app-display-field [type]="meta.fields[key].type" [value]="history.data[history.index][key]"
                       [choices]="meta.fields[key].choices"></app-display-field>
      </div>
    </div>
    <div class="row">
      <div
          [ngClass]="{'has-error': meta.fields.shape.hasError, 'offset-md-2 col-md-7': history.isVisible, 'offset-md-3 col-md-9': !history.isVisible}"
          *ngIf="meta.fields.shape && meta.fields.shape.hasError">
        <label class="control-label" *ngIf="meta.fields.shape.hasError" class="has-error">A location is
          required.</label>

      </div>
    </div>
    <div class="row" *ngIf="meta.featureService !== undefined && showCoordinateInput">

      <div
          [ngClass]="{'has-error': meta.fields.shape.hasError, 'col-md-2': history.isVisible, 'col-md-3': !history.isVisible}">
        <label class="control-label">Latitude *</label>
      </div>
      <div
          [ngClass]="{'has-error': meta.fields.shape.hasError, 'col-md-7': history.isVisible, 'col-md-9': !history.isVisible}">
        <input class="form-control" [(ngModel)]="coordinates.latitude" name="latitude" type="text"/>
      </div>
    </div>
    <div class="row" *ngIf="meta.featureService !== undefined && showCoordinateInput">
      <div
          [ngClass]="{'has-error': meta.fields.shape.hasError, 'col-md-2': history.isVisible, 'col-md-3': !history.isVisible}">
        <label class="control-label">Longitude *</label>
      </div>
      <div
          [ngClass]="{'has-error': meta.fields.shape.hasError, 'col-md-7': history.isVisible, 'col-md-9': !history.isVisible}">
        <input class="form-control" [(ngModel)]="coordinates.longitude" name="longitude" type="text"/>
      </div>
    </div>
    <div class="row">
      <div
          [ngClass]="{'col-sm-9': history.isVisible, 'col-sm-12': !history.isVisible}"
          *ngIf="item.last_edited_user !== '' && item.last_edited_user !== undefined && item.last_edited_user !== null">
        <div class="pull-right">
          Last edited by {{ item.last_edited_user }} on {{ item.last_edited_date | date:'short' }}
        </div>
      </div>
      <div class="col-sm-3" *ngIf="history.isVisible">
        <div class="pull-right">
          Edited by {{ history.data[history.index].last_edited_user }}
        </div>
      </div>
    </div>
    <div class="row" style="padding-top:10px;">
      <div class="col-md-12">
        <div style="text-align: center; padding:25px; position: absolute; top: 46%; z-index: 999; left: 46%;"
             *ngIf="map_loading">
          <i class="fa fa-pulse fa-spinner fa-2x" style="color: black;"></i>
        </div>
        <div id="waltersModalMapDiv" style="height: 400px;"
             [style]="{'display': (meta.featureService === undefined ? 'none' : '')}">
          <div id="zoomToolbar" class="btn-toolbar">
            <div class="btn-group">
              <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()">
                <span class="fa fa-plus"></span>
              </button>
              <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()">
                <i class="fa fa-minus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="!disableSave">
  <button class="btn btn-default" *ngIf="!saving" (click)="cancel()">Cancel</button>
  <button class="btn btn-primary" *ngIf="meta.add_another_reset !== undefined && item.globalid === undefined"
          [disabled]="saving" (click)="submit(true)">
    <span *ngIf="!saving">Submit and Add Another</span>
    <span *ngIf="saving"><i class="fa fa-spinner fa-pulse"></i></span>
  </button>
  <button class="btn btn-primary" [disabled]="saving" (click)="submit(false)">
    <span *ngIf="!saving">Submit</span>
    <span *ngIf="saving"><i class="fa fa-spinner fa-pulse"></i></span>
  </button>
</div>
<div class="modal-footer" *ngIf="disableSave">
    <button class="btn btn-primary" (click)="ok()">Ok</button>
</div>
<script type="text/ng-template" id="custom-timepicker.html">
  <table class="uib-timepicker">
    <tbody>
    <tr>
        <td class="form-group uib-time hours" [class]="{'has-error': invalidHours}">
            <input style="width:50px;" type="text" placeholder="HH" [(ngModel)]="hours" (change)="updateHours()"
                   class="form-control text-center" [readonly]="::readonlyInput" maxlength="2"
                   tabindex="{{::tabindex}}" [disabled]="noIncrementHours()" (blur)="blur()">
        </td>
        <td class="uib-separator">:</td>
        <td class="form-group uib-time minutes" [class]="{'has-error': invalidMinutes}">
            <input style="width:50px;" type="text" placeholder="MM" [(ngModel)]="minutes" (change)="updateMinutes()"
                   class="form-control text-center" [readonly]="readonlyInput" maxlength="2"
                   tabindex="{{::tabindex}}" [disabled]="noIncrementMinutes()" (blur)="blur()">
        </td>
        <td *ngIf="showSeconds" class="uib-separator">:</td>
        <td class="form-group uib-time seconds" [class]="{'has-error': invalidSeconds}" *ngIf="showSeconds">
            <input style="width:50px;" type="text" placeholder="SS" [(ngModel)]="seconds" (change)="updateSeconds()"
                   class="form-control text-center" [readonly]="readonlyInput" maxlength="2" tabindex="{{::tabindex}}"
                   [disabled]="noIncrementSeconds()" (blur)="blur()">
        </td>
        <td *ngIf="showMeridian" class="uib-time am-pm">
            <button type="button" [class]="{disabled: noToggleMeridian()}" class="btn btn-default text-center"
                    (click)="toggleMeridian()" [disabled]="noToggleMeridian()"
                    tabindex="{{::tabindex}}">{{ meridian }}</button>
        </td>
    </tr>
    </tbody>
</table>

</script>
